<form ngNativeValidate (ngSubmit)="newVoucher()">
  <div class="input__container col-40percent">
    <label for="discount-rate">Rabattsats (%)</label>
    <input 
      required
      id="discount-rate"
      type="text"
      wooPercentFormatter
      [wooMinValidator]="0.001"
      [wooMaxValidator]="0.999"
      name="discount-rate"
      [(ngModel)]="voucher.discount"
    >
  </div>
  @if(agencies()?.length > 0) {
    <div class="col-12">
      <div class="select__container">
        <label for="agency">Byrå</label>
        <select id="agency" name="agency" [(ngModel)]="voucher.agency.id" class="no-valid-color">
          @for (agency of agencies(); track $index) {
            <option [value]="agency.id">{{agency.nickname}}</option>
          }
        </select>
        </div>
      </div>
  }
  @for (condition of conditions(); track $index) {
    <div class="select__container">
      <label for="condition--{{condition.type}}">{{convertVoucherConditions(condition.type)}}</label>
      <select
        id="condition--{{condition.type}}"
        name="condition--{{condition.type}}"
        [(ngModel)]="voucher.conditions[$index].values"
        required
      >
        <option value=""></option>
        @for (value of condition.accepted_values; track $index) {
          <option [value]="[value]">{{convertDiscount(value)}}</option>
        }
      </select>
    </div>
  }
  <div class="margin-top--3x">
    <button type="submit" class="button primary-1" [disabled]="!validDiscountAmount()">Lägg till rabatt</button>
    <button type="button" class="link" (click)="onAbort.emit()">Avbryt</button>
  </div>
</form>
